import { fromCamelToPascal } from "@pjs/http";
import { untilComplete } from "@pjs/observables";
import { grantAdminTemporaryAccess } from "../functions/GrantAdminTemporaryAccess.function";
import { TemporaryAccessState } from "../enums/TemporaryAccessState";
import { ITemporaryAccessFormData } from "../interfaces/ITemporaryAccessFormData";
import { temporaryAccessDetails } from "../consts/TemporaryAccessDetails.const";

export const grantTemporaryAdminAccess = (formData: ITemporaryAccessFormData): void => {
    const document = temporaryAccessDetails.get();

    document.model.state.update({ descriptor: TemporaryAccessState.GrantPending });

    grantAdminTemporaryAccess(
        fromCamelToPascal({
            reason: formData.reason,
            days: formData.days,
            adminUserId: formData.recipient
        })
    )
        .pipe(untilComplete(document.changeStream))
        .subscribe({
            next: (details) => {
                document.model.details.update(details);
                document.model.state.update({ descriptor: TemporaryAccessState.OK });
            },
            error: () => {
                document.model.state.update({ descriptor: TemporaryAccessState.GrantFailed });
            }
        });
};
